"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
var yup = __importStar(require("yup"));
var ciaociao_types_1 = require("@ctxhou/ciaociao-types");
var errorMessages = (_a = {},
    _a[ciaociao_types_1.EnLocale] = {
        required: 'This field is required',
        email: 'Please input a valid email',
    },
    _a[ciaociao_types_1.ZhHantLocale] = {
        required: '此欄位為必填',
        email: '請輸入正確的 Email 格式',
    },
    _a);
var genYupValidatorBySchema = function (_a) {
    var schema = _a.schema, _b = _a.locale, locale = _b === void 0 ? ciaociao_types_1.ZhHantLocale : _b;
    var validatorShape = {};
    schema.forEach(function (item) {
        var _a;
        var validator = yup.string();
        item.validators.forEach(function (_a) {
            var logic = _a.logic;
            if (logic === 'required') {
                validator = validator.required(errorMessages[locale].required);
            }
            else if (logic === 'email') {
                validator = validator.email(errorMessages[locale].email);
            }
        });
        validatorShape = __assign(__assign({}, validatorShape), (_a = {}, _a[item.id] = validator, _a));
    });
    return yup.object().shape(validatorShape);
};
exports.default = genYupValidatorBySchema;
